import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
//import { ArrowUpIcon } from '../../icons';
import { Button } from '../button';
import { Text } from '../text';
import { ArrowUpIcon } from '@/icons/arrow-up-icon';
export const AccordionItem = ({ label, children, isOpen: isAccordionItemOpen = false, className = '', headerClassName = '', containerClassName = '', onToggle, labelVariant = 'default', }) => {
    const [isOpen, setIsOpen] = useState(isAccordionItemOpen);
    const handleToggle = () => {
        if (onToggle) {
            onToggle(!isOpen);
        }
        setIsOpen(!isOpen);
    };
    useEffect(() => {
        setIsOpen(isAccordionItemOpen);
    }, [isAccordionItemOpen]);
    return (_jsxs("div", { className: className, children: [_jsxs("div", { className: `flex justify-between items-center ${headerClassName}`, onClick: handleToggle, children: [typeof label === 'string' ? _jsx(Text, { variant: labelVariant, children: label }) : label, _jsx(Button, { variant: 'text', onClick: handleToggle, className: 'flex items-center justify-between rounded-none', children: _jsx(ArrowUpIcon, { rotate: !isOpen ? 180 : 0 }) })] }), isOpen && (_jsx("div", { className: `transition-all duration-200 ${containerClassName}`, children: children }))] }));
};
